<template>
	<sa-page-layout :btnBackVisible="false" :btnEditVisible="false" :btnRefreshVisible="false" :linkback="linkback" :pathResource="pathResource">
		<template slot="table-body">
			<b-tabs id="tabsRsaAccettazioneEdit" ref="tabsRsaAccettazioneEdit" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
				<b-tab title="Menu">
					<div class="sa-intallation-section">
						<div v-for="menu of jsonData.menu" :key="menu.serverTest">
							<div class="sa-intallation-section-header">
								<span>{{ menu.serverText }}</span>
								<span :class="menu.serverText === menu.localText ? 'sa-intallation-green' : 'sa-intallation-red'">{{ menu.localText }}</span>
								<span>{{ menu.verified }}</span>
							</div>
							<div class="sa-intallation-section-container">
								<table class="sa-custom-table">
									<tr style="border: 1px solid black">
										<th>Chiave</th>
										<th>G.H.S.</th>
										<th>Locale</th>
										<th>---</th>
									</tr>
									<tr v-for="element of menu.elements" :key="element.name">
										<td style="border: 1px solid black">{{ element.name }}</td>
										<td style="border: 1px solid black">{{ element.serverValue }}</td>
										<td style="border: 1px solid black">{{ element.localValue }}</td>
										<td style="border: 1px solid black">{{ element.verified }}</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</b-tab>
			</b-tabs>
		</template>
	</sa-page-layout>
	<!-- <installation-component></installation-component> -->
</template>

<script>
//import InstallationComponent from "../components/InstallationComponent.vue";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { SaPageLayout },
	data() {
		return {
			activeTabIndex: 0,
			linkback: null,
			pathResource: "/installation/checkmenu",
			jsonData: {
				menu: [],
			},
			// jsonData: {
			// 	menu: [
			// 		{
			// 			serverText: "Agenda",
			// 			localText: "Agenda",
			// 			verified: false,
			// 			elements: [
			// 				{ name: "primaryKey", serverValue: "null", localValue: "null", verified: true },
			// 				{ name: "createUser", serverValue: "null", localValue: "null", verified: true },
			// 			],
			// 		},
			// 		{ serverText: "Home", localText: "Home Test", verified: false, elements: [{ name: "primaryKey", serverValue: "null1", localValue: null, verified: true }] },
			// 	],
			// },
		};
	},
	mounted() {
		let me = this;
		me.loadCheckMenu();
	},
	methods: {
		loadCheckMenu() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource, {}, me.loadCheckMenuSuccess, me.loadCheckMenuError);
		},
		loadCheckMenuSuccess(response) {
			let me = this;
			me.jsonData.menu = response.data.data;

			me.$emit("afterLoadData");
		},
		loadCheckMenuError(error) {
			let me = this;
			console.error("Errore durante il caricamento dei dati:", error);
			me.$emit("afterLoadData");
		},
		getLocalMenu(menu) {
			return this.jsonData.localMenu.find((element) => element.primaryKey === menu.primaryKey);
		},
		onInputTabs() {},
	},
};
</script>

<style>
.sa-intallation-section {
	display: block;
	height: 100%;
	overflow: auto;
	padding-bottom: 50px;
}
.sa-intallation-section-header {
	display: flex;
}
.sa-intallation-section-header span {
	flex: 1;
}
.sa-intallation-section-container {
	padding-left: 50px;
	padding-right: 10px;
	background-color: #f0f0f0;
}
.sa-intallation-red {
	background-color: #ffa8a8;
}
.sa-intallation-green {
	background-color: #a8ffa8;
}
</style>
